import type { schemaType as cottagesRecommendedSchemaType } from '~~/shared/api/rurality/v3/cottages/recommended-by-cottage/detail/schema'
import type { CottagePageRecommended } from '~~/modules/views/cottage/entities/CottagePage'
import type { CottageSwiperRecommended } from '~~/modules/views/cottage/entities/CottageSwiperRecommended'
import type { CottageCard } from '~~/modules/views/cottage/entities/CottageCard'

export const useToCottagePageRecommended = () => {
  const fromRurality = (params: {
    cottagesRecommended: cottagesRecommendedSchemaType
  }): CottagePageRecommended | null => {
    const parsedRecommended = params.cottagesRecommended
    const processRecommended = (): [
      CottageSwiperRecommended,
      CottageSwiperRecommended,
      CottageSwiperRecommended,
    ] => {
      const cottageSwiperRecommended: CottageSwiperRecommended =
        parsedRecommended.recommendedCottages.map(item => {
          const cottageCard: CottageCard = {
            src: item.media.url,
            url: item.url,
            name: item.name,
            zone: item.village.name,
            numComments: item.numComments,
            rate: item.rate,
          }

          return cottageCard
        })

      return [
        cottageSwiperRecommended.slice(0, 4),
        cottageSwiperRecommended.slice(4, 8),
        cottageSwiperRecommended.slice(8, 12),
      ]
    }
    return processRecommended()
  }

  return { fromRurality }
}
